const actions = {
	CLEAR_CACHE: "CLEAR_CACHE",
	STORAGE_LOADED: "STORAGE_LOADED",
	UPDATE_CART: "UPDATE_CART",
	UPDATE_BAND_CART: "UPDATE_BAND_CART",
	HANDLE_SNACKBAR: "HANDLE_SNACKBAR",
	MANAGE_DISCOUNT: "MANAGE_DISCOUNT",
};

export default actions;
